import { render, staticRenderFns } from "./TheFormDiscounts.vue?vue&type=template&id=54059b3a&scoped=true&"
import script from "./TheFormDiscounts.vue?vue&type=script&lang=ts&"
export * from "./TheFormDiscounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54059b3a",
  null
  
)

export default component.exports